<template>
  <div class="row">
    <div class="row mb-2">
      <label>{{ lang('Domain') }}</label>
      <el-select
        v-model="selectedCustomDomain"
        :placeholder="lang('Select Domain')"
        class="pro-edt-select"
        style="margin-right: 10px"
        id="selectedCustomDomain"
        @change="generateGoalSelectionList()"
      >
        <el-option v-for="item in ddlGoalsListDomain" :key="item" :label="item" :value="item"> </el-option>
      </el-select>
    </div>
    <div class="row mb-2">
      <label>{{ lang('Goals') }}</label>
      <el-select
        v-model="selectedCustomGoal"
        :placeholder="lang('Select Goal')"
        class="pro-edt-select"
        style="margin-right: 10px"
        id="ddlClassID"
        @change="fetchCustomGoals()"
      >
        <el-option v-for="item in customGoalSelectionList" :key="item.goal" :label="item.goal" :value="item.goal"> </el-option>
      </el-select>
      <div class="col-lg-12 mt-2 divKeyInKeySkillorCld">
        <label>{{ lang('Learning Goals') }}</label>
        <input type="text" class="form-control inputKeySkillCLD" v-model="customGoalIndicator" :placeholder="lang('Enter Indicator')" />
      </div>
      <div class="col-lg-12" v-if="selectedCustomDomain !== '' && selectedCustomGoal !== '' && customGoalIndicator !== ''">
        <el-button type="primary" class="mt-2 mb-2" @click="insertCustomGoal()">
          {{ lang('Add') }}
        </el-button>
      </div>
    </div>
    <div class="col-lg-12">
      <div v-if="fetchedCustomGoalList.length > 0">
        <data-tables :data="fetchedCustomGoalList">
          <el-table-column v-for="goal in CustomGoalInfo" :prop="goal.prop" :label="goal.label" :key="goal.key"> </el-table-column>
          <el-table-column label="Assign" min-width="100px">
            <template slot-scope="scope">
              <el-button type="primary" @click="$emit('assignCustomGoal', scope.row)">
                <!--                    levelSelect(scope.row.PK_Course_ID,scope.row.CRS_Level,scope.row.ClS_FK_Semester_ID-->
                {{ lang('Assign') }}
              </el-button>
            </template>
          </el-table-column>
        </data-tables>
      </div>

      <div class="empty-list_image" v-else>
        <strong>{{ lang('No Data Found') }}...</strong>
        <img src="../../../assets/notfound.png" />
      </div>
    </div>
  </div>
</template>

<script>
import DataSource from '../../../data/datasource'
import { lang } from '../../../locale'

export default {
  name: 'AssignCustomPlanner',
  props: ['ddlGoalsListDomain', 'ddlGoalsList', 'assignCustomGoal'],
  data() {
    return {
      selectedCustomDomain: '',
      customGoalSelectionList: [],
      selectedCustomGoal: '',
      fetchedCustomGoalList: [],
      customGoalIndicator: '',
      CustomGoalInfo: [
        {
          //   prop: "PlnCusDomain",
          //   label: "Domain"
          // }, {
          //   prop: "PlnCusGoalsITL",
          //   label: "Goal"
          // }, {
          prop: 'PlnCusIndicator',
          label: lang('Indicator'),
        },
      ],
    }
  },
  methods: {
    lang,
    async generateGoalSelectionList() {
      console.log(this.ddlGoalsList, 'this.ddlGoalsList')
      let customgoalgoallist = this.ddlGoalsList.filter(n => n.PlnMasDomain === this.selectedCustomDomain)
      this.customGoalSelectionList = []
      // item.PlnMasGoalsITL
      let temp = []
      let list = []
      console.log(customgoalgoallist, 'customgoalgoallist')

      customgoalgoallist[0].ArrObj_Items.forEach(m => {
        m.ArrObj_Items.forEach(d => {
          console.log(d, 'd')

          if (temp.indexOf(d.PlnMasGoalsITL) < 0) {
            temp.push(d.PlnMasGoalsITL)
            list.push({ goal: d.PlnMasGoalsITL })
          }
        })
      })

      this.customGoalSelectionList = list
    },
    async fetchCustomGoals() {
      try {
        this.fetchedCustomGoalList = []
        const response = await DataSource.shared.fetchCustomGoals(this.selectedCustomDomain, this.selectedCustomGoal)
        if (response.code === '3' || response.code === '99') {
        } else {
          this.fetchedCustomGoalList = response.Table
        }
      } catch (e) {
        this.results = e
      }
    },
    async insertCustomGoal() {
      await DataSource.shared.insertCustomGoal(this.selectedCustomDomain, this.selectedCustomGoal, this.customGoalIndicator)
      await this.fetchCustomGoals()
      this.customGoalIndicator = ''
      // console.log()
    },
  },
}
</script>
